import React, { ReactNode } from "react";
import { Box, styled } from "@mui/material";

interface DiamondFrameProps {
  children?: ReactNode;
  size?: number;
}

const DiamondOuter = styled(Box, {
  label: "DiamondOuter",
  shouldForwardProp: (prop) => prop !== "size",
})<{ size: number }>(({ size }) => ({
  width: size,
  height: size,
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const DiamondContent = styled(Box, {
  label: "DiamondContent",
})(() => ({
  position: "relative",
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "95%",
  height: "95%",
}));

const IconImage = styled("img", {
  label: "DiamondIconImage",
})(() => ({
  width: "100%",
  height: "100%",
  objectFit: "contain",
}));

export const DiamondFrame = ({ children, size = 192 }: DiamondFrameProps) => {
  return (
    <DiamondOuter size={size}>
      <DiamondContent>{children}</DiamondContent>
    </DiamondOuter>
  );
};

export const DiamondWithIcon = ({
  iconUrl,
  iconAlt,
  size = 192,
}: {
  iconUrl?: string;
  iconAlt?: string;
  size?: number;
}) => {
  return (
    <DiamondFrame size={size}>
      {iconUrl && <IconImage src={iconUrl} alt={iconAlt || ""} />}
    </DiamondFrame>
  );
};
